import axios from 'axios';
export const retry = (failureCount, error) => {
    var _a;
    if (axios.isAxiosError(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
        return false;
    }
    // It runs the query three times before throwing an error.
    return failureCount < 2;
};
export const getDefaultErrorMessage = (error) => {
    var _a, _b, _c, _d, _e, _f;
    let message = 'Something went wrong.';
    if (axios.isAxiosError(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.title)) {
        message = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data.title;
    }
    else if (axios.isAxiosError(error) && ((_c = error.response) === null || _c === void 0 ? void 0 : _c.data.body)) {
        message = getErrorMessageFromBodyAttribute((_d = error.response) === null || _d === void 0 ? void 0 : _d.data.body);
    }
    else if (axios.isAxiosError(error) && ((_e = error.response) === null || _e === void 0 ? void 0 : _e.data.message)) {
        message = (_f = error.response) === null || _f === void 0 ? void 0 : _f.data.message;
    }
    else if (error instanceof Error && error.message) {
        message = error.message;
    }
    return message;
};
export const createOnError = (notify) => (error) => {
    notify(getDefaultErrorMessage(error));
};
export const createQueryCacheOnError = (notify) => (error, query) => {
    var _a, _b;
    // Make it possible to override QueryCache error with single Query options.
    if ('onError' in query.options)
        return;
    if (axios.isAxiosError(error) &&
        (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 || ((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 403)) {
        console.error(error);
        return;
    }
    return createOnError(notify)(error);
};
export const getErrorMessageFromBodyAttribute = (body) => {
    const errors = new Set();
    const getErrorString = (obj) => {
        const keys = Object.keys(obj);
        keys.forEach((key) => {
            if (Array.isArray(obj[key])) {
                errors.add(`${key}: ${obj[key]}`);
            }
            else if (typeof obj[key] === 'object') {
                getErrorString(obj[key]);
            }
            else {
                errors.add(`${key}: ${obj[key]}`);
            }
        });
    };
    getErrorString(body);
    return Array.from(errors).join('\n');
};
